import { BaseEntityClass } from './base-class.model';
import { User, QuotationItem } from '.';
import { QuotationState, AuthType, BusinessMath, PrestashopInfo } from 'src/app/shared';

export class Quotation extends BaseEntityClass<Quotation> {
  id_cotizr_quotation: string;
  id_customer: number;
  emails: string[];
  items: QuotationItem[];
  subtotal: number;
  status: QuotationState;
  user: { name: string; email: string; };
  receiver: string;
  phone_number: string;
  user_type: AuthType;
  company_address: string;
  company_name: string;
  identification: string;
  date_created: string;
  currency: string;
  dolar_rate: number;
  iva_type: string;
  discount: number;
  total_mensajes:number

  getSubtotal(items: QuotationItem[]) {
    const discount = this.discount ? 1 + (this.discount/100) : 1;
    return (BusinessMath.totalIVAFromProductArray(items,PrestashopInfo.IVA,this.currency,this.dolar_rate,this.iva_type)/discount).toFixed(2);
  }

  toDBObject(isCreation: boolean = false) {
    const calculatedItems: QuotationItem[] = this.items.map((x) => {
      x.name = x.name.replace(/["']/g, '');
      x.total = x.ammount * x.price;
      return x;
    });

    const obj: any = {
      id_customer: this.id_customer,
      emails: JSON.stringify(this.emails),
      items: JSON.stringify(calculatedItems),
      subtotal: this.getSubtotal(calculatedItems),
      status: this.status,
      user: JSON.stringify(this.user),
      receiver: this.receiver,
      phone_number: this.phone_number,
      user_type: this.user_type,
      company_address: this.company_address,
      company_name: this.company_name,
      identification: this.identification,
      currency: this.currency,
      dolar_rate: this.dolar_rate,
      iva_type: this.iva_type,
      discount:this.discount
    };

    if (!isCreation) {
      obj.date_created = this.date_created;
      obj.id_cotizr_quotation = this.id_cotizr_quotation;
    }

    return obj;
  }
}
